import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class NumberService {

    parseCzechFloat(val): number {
        if (val) {
            val += ''
            val = val.replace(',', '.')
        }
        return isNaN(parseFloat(val)) ? 0 : parseFloat(val)
    }

    parseFloatOrZero(val): number {
        return isNaN(parseFloat(val)) ? 0 : parseFloat(val)
    }

    /**
     * Round to 2 decimals (only when necessary: roundToTwo(1.7777777) = 1.78 and roundToTwo(10) = 10 )
     * https://stackoverflow.com/a/11832950
     */
    roundToTwo(num: number): number {
        return Math.round((num + Number.EPSILON) * 100) / 100
    }

    roundToTwoIfNumeric(value): string | number {
        if (isNaN(value)) {
            return value
        } else if (!value) {
            return ''
        } else {
            return this.roundToTwo(this.parseFloatOrZero(value))
        }
    }

    isPositiveNumeric(value: any): boolean  {
        let numeric = /^[-]?\d+([\.\,]\d*)?$/.test(value)
        if (!numeric) {
            return false
        }
        // Replace ',' with '.' for consistent decimal parsing
        value = String(value).replace(',', '.')

        if (parseFloat(value) > 0) {
            return true
        }
    }

    isNumeric(value: any, allowDecinmals: boolean = false, infiiniteDecimals: boolean = false): boolean  {
        if (value == null || value === '') {
            return false // Handle null or empty values
        }
        // Define regex based on `twoDecimal` flag:
        // - If `twoDecimal` is true: Match numbers with up to 2 decimal places.
        // - Otherwise: Match numbers with any number of decimal places.
        const numericRegex = !allowDecinmals ? /^\d+$/ : !infiiniteDecimals ? /^-?\d+([.,]\d{1,2})?$/ : /^-?\d+([.,]\d*)?$/
        if (!numericRegex.test(value)) {
            return false
        }

        // Replace ',' with '.' for consistent decimal parsing
        value = String(value).replace(',', '.')

        // Check if the parsed value is greater than or equal to 0
        return parseFloat(value) >= 0 // Return true for non-negative numbers
    }
}